<template>
  <div id="jiageshenheNew">
    <van-sticky>
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickNext"
      >
      </van-nav-bar>
    </van-sticky>
    <!-- <van-pull-refresh v-model="isLoading"
                      success-text="刷新成功"
                      @refresh="onRefresh"> -->
    <!-- <div style="background-color: #ffff00;height:0.3rem"></div> -->
    <!-- <van-sticky offset-top="1.0558rem"> -->
         <!-- 返回顶部 -->
    <div class="toTopIcon" v-if="btnFlag">
        <van-icon name="upgrade" @click.stop="backTop" class="go-top" />
    </div>
    <div class="xinxi" v-if="false">
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            期号：
          </van-col>
          <van-col span="7" class="twoLine">
            {{ exeno }}
          </van-col>
          <van-col span="5">
            <div class="blue-box"></div>
            截止时间：
          </van-col>
          <van-col span="7" class="twoLine">
            {{ priceDate }} {{ lateReportTime }}
          </van-col>
        </van-row>
      </div>

      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            任务名称：
          </van-col>
          <van-col span="19" class="twoLine">{{ taskName }}</van-col>
        </van-row>
      </div>

      <div >
          <van-row>
            <van-col span="6">
                <div class="blue-box"></div>监测点筛选：
            </van-col>
            <van-col span="18" class="twoLine" >
              <!-- <van-button @click="jump">点击跳转</van-button> -->
              <van-search v-model="dropdownInput"  @focus="hideTabs" @input="fuzzyQuery" placeholder="请输入监测点名称" />
              <div class="wrapper" v-if="showDrop" @click="showTabs">
              <van-list
                class="block"
                v-model="loading1"
                  :finished="finished"
                  finished-text=""
                  @load="onLoad"
              >
                <van-cell v-for="(item,index) in inputTable" :key="index" :title="item.text"
                @click.stop="dropClick(item.value, item.text)" />
              </van-list>
            </div>
            </van-col>
          </van-row>
        </div>
      <!-- <van-row>
          <van-col span="5">
            <div class="blue-box"></div>采集地点：
          </van-col>
          <van-col span="7" class="twoLine">{{stationName}}</van-col>
            <van-col span="5">
              <div class="blue-box"></div>任务名称：
            </van-col>
            <van-col span="7" class="twoLine">
              {{taskName}}
            </van-col>
         </van-row> -->
    </div>
    <!-- </van-sticky> -->
    <van-sticky offset-top="1.0558rem">
      <div class="boxTitle">
        <van-row type="flex" justify="center" align="center">
          <van-col span="2" align="center">序号</van-col>
          <van-col span="7" align="center">商品</van-col>
          <van-col span="8" align="center">本期价格</van-col>
          <van-col span="4" align="center">上期价格</van-col>
          <van-col span="3" align="center">环比%</van-col>
        </van-row>
      </div>
    </van-sticky>

    <div class="table">
      <van-card v-for="items in stationList" :key="items.value">
        <template #title>
          <div class="title" :id="items.value">
            {{ items.text }}
            <van-divider style="margin: 0; color: #2f2f2f" />
          </div>
        </template>
        <template #desc>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text=""
            @load="onLoad"
            style="padding-bottom: 0.2rem"
          >
            <div
              :class="[index % 2 == 0 ? 'even' : 'odd']"
              v-for="(item, index) in list"
              :key="index"
            >
             <div v-if="item.StationCode === items.value">
              <van-row type="flex" justify="center" align="center">
                <van-col span="2" align="center">
                  <div style="width: 50%;background-color: red;color:#fff" v-if="!item.isGoods && ((item.itemNumbersShow && !item.itemNumbers) || (item.originBrandShow && !item.originBrand))">
                      {{ index + 1 }}
                  </div>
                  <div v-else-if="item.isGoods || (!item.itemNumbersShow && !item.originBrandShow)">
                      {{ index + 1 }}
                  </div>
                  <div v-else  style="width: 50%;background-color: green;color:#fff">
                    {{ index + 1 }}
                  </div>
                </van-col>
                <van-col
                  span="7"
                  :style="{
                    color:
                      item.VarietyCodeNew == item.VarietyCode || item.isGoods == 1 ||
                      (item.ThisPrice == 0 && item.ThisPrice != '') || (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) || (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0)
                        ? 'red'
                        : 'blue',
                  }"
                  class="contentLimit"
                  @click="clickStoreName(item, index)"
                  >{{ item.VarietyName }}--{{ item.StandardName }}--{{
                    item.TargetName
                  }}</van-col
                >
                <van-col span="1" align="center">&emsp;</van-col>
                <van-col span="8">
                  <div class="input">
                    <input
                      v-model="item.ThisPrice"
                      :class="{ bianhui: saveState || item.isGoods == 1}"
                      @blur="changePrice(index)"
                      type="number"
                      :style="{
                        background:
                          (item.ThisPrice == 0 && item.ThisPrice != '') || saveState
                            ? '#efe7e7'
                            : '',
                      }"
                      oninput="if(value<0)value=0; if(value>99999999)value=99999999"
                      min="0"
                      max="99999999"
                      required
                    />
                  </div>
                  {{ item.UnitName }}
                </van-col>
                <van-col span="2" align="right">{{ item.ringPrice }}</van-col>
                <!-- 环比：（本期数-上期数）/上期数×100% -->
                <van-col
                  span="3"
                  align="right"
                  :style="{ color: item.styleColor }"
                  v-model="item.hbNum"
                  >{{ item.hbNum }}</van-col
                >
                <van-col span="1" align="right">&emsp;</van-col>
              </van-row>
             </div>
            </div>
          </van-list>
          <div style="height:1rem;background-color:#f0f2f1" v-if="lastStation===items.value" ></div>
        </template>
      </van-card>
    </div>
    <!-- 按钮 -->
    <div class="bottom">
      <div style="display:flex;box-shadow: 0px -1px 10px #0000004d;height: 100%;align-items: center;">
        <!-- <div :class="{ bianhui: shState }" offset="1" style="text-align: center;flex: 1; position: relative;">
          <v-button class="btn1" @click="tongguo">{{ titleShow }}</v-button>
        </div>
        <div :class="{ bianhui: cxState, yincang: cxShiState }" offset="1" style="text-align: center;flex: 1; position: relative;">
          <v-button class="btn1" @click="chexiao">撤销审核</v-button>
        </div> -->
        <div :class="{ bianhui: saveState }" offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1" @click="saveClick">保存</v-button>
        </div>
        <div  offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1 btn2" @click="onClickLeft">取消</v-button>
        </div>
        <!-- <div :class="{ bianhui: backState, yincang: thCityState }" offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1" @click="tuihui">退回</v-button>
        </div>
        <div  offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1 btn2" @click="chaKanRiZhi">查看日志</v-button>
        </div> -->
      </div>
    </div>

    <!-- 商品详细信息弹窗 -->
     <detailDialog
      ref="detailRef"
      :saveState="saveState"
      @saveBasic="saveBasic"
      :levelNum="levelNum"
     ></detailDialog>

    <!-- </van-pull-refresh> -->
    <van-popup v-model="showDetial" :style="{ width: '75%' }">
      <van-field v-model="shopIndex1" label="序号" disabled />
      <van-field
        v-model="shopName"
        label="商品"
        disabled
        rows="1"
        autosize
        type="textarea"
      />
      <div style="display: flex;border-bottom: 1px solid  #ebedf0;margin-left: 0.2rem;">
        <div class="goodIs">无此品种</div>
        <van-checkbox v-model="isGoods" shape="square" @change="changeIsGoods" :disabled="saveState"></van-checkbox>
      </div>
      <van-field
        v-model="bqPrice"
        label="本期"
        :formatter="formatter"
        type="number"
        :disabled="isGoods || saveState"
        class="g_disabled"
      />
      <van-field
        v-if="ifShow == 1"
        v-model="brand"
        rows="2"
        label="品牌"
        type="text"
        maxlength="50"
        disabled
      />
      <van-field v-if="originBrandShow&& !isGoods" v-model="originBrand"
                 label="品牌产地"
                 class="long-label"
                 type="text"
                 maxlength="50"/>
      <van-field v-if="itemNumbersShow&& !isGoods" v-model="itemNumbers"
                 label="数量"
                 type="text"/>
      <van-field
        v-model="content"
        rows="3"
        autosize
        label="波动原因说明"
        type="textarea"
        class="long-txt g_disabled"
        maxlength="50"
        :disabled="saveState"
        show-word-limit
      />
      <!-- <van-field
        v-model="comments"
        rows="3"
        autosize
        label="备注"
        type="textarea"
        maxlength="50"
        show-word-limit
      /> -->
      <van-row type="flex" justify="center" align="center">
        <van-col span="6">
          <v-button class="btn" @click="closeBasic()">取消</v-button>
        </van-col>
        <!-- <van-col span="6" offset="4">
          <v-button
            class="btn"
            :class="{ bianhui: saveState }"
            @click="saveBasic()"
            >保存</v-button
          >
        </van-col> -->
      </van-row>
    </van-popup>
    <!--退回原因-->
    <van-popup v-model="showBackInfo" :style="{ width: '75%' }">
      <van-field
        v-model="backInfo"
        rows="6"
        autosize
        class="long-label2"
        label="退回原因:"
        type="textarea"
        maxlength="50"
        show-word-limit
      />
      <van-row type="flex" justify="center" align="center">
        <van-col span="6">
          <v-button class="btn" @click="closeBackInfo()">取消</v-button>
        </van-col>
        <van-col span="6" offset="4">
          <v-button class="btn" @click="saveBackInfo()">保存</v-button>
        </van-col>
      </van-row>
    </van-popup>
    <!-- 商品说明弹窗end -->
    <!-- 查看日志弹窗start -->
    <van-popup
      v-model="showLog"
      position="bottom"
      :style="{ height: '60%', backgroundColor: '#f0f2f1' }"
      id="logList"
    >
      <van-sticky>
        <div class="boxTitle">
          <van-row type="flex" justify="center" align="center">
            <van-col span="24" align="center">日志详情</van-col>
          </van-row>
        </div>
      </van-sticky>
      <div class="logTable" style="height: calc(100% - 1rem); overflow-y: auto">
        <div class="no-con" v-if="logList.length == 0">暂无数据</div>
        <div class="logBox" v-for="(item, index) in logList" :key="index">
          <van-row type="flex" justify="center" align="center">
            <van-col span="10">{{ item.editUser }}</van-col>
            <van-col span="10">{{ item.editTime }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" align="center">
            <van-col span="20">{{ item.recordType }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" align="center">
            <van-col span="20">{{ item.detailInfo }}</van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { loading } from "@/common/loading";
import {
  getExamDetailsList,
  provinceCheck, //省审核
  provinceRevoke, //撤销省审核
  provinceRedo, //省退回
  provinceSavePriceRow, //省保存
  cityCheck, //市审核
  cityRedo, //市退回
  citySaveRow, //市保存
  countyCheck, //区县审核
  countyRedo, //区县退回
  countySaveRow, //区县保存
  getDateRecord, //查看日志
  getTodayCheckNew,
  checkLogin, //检查登陆状态
  getCheckStationList,saveRow, upOK,
} from "@/api/baseMsg";
import { Toast } from "vant";
import detailDialog from "@/components/detailDialog";
import rulesInfoDeal from '@/utils/dataRules.js';

export default {
  name: "jiageshenheNew",
  components: {
    detailDialog
  },
  data() {
    return {
      title: "均价审核详情",
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      taskCode: this.$route.query.taskCode,
      exeno: this.$route.query.exeno,
      ExeNo: this.$route.query.ExeNo,
      taskID: this.$route.query.taskId,
      shopId: this.$route.query.shopId,
      shispflag: this.$route.query.shispflag, //市审核
      shengspflag: this.$route.query.shengspflag, //市审核 //1蓝2绿3灰
      ythflag: this.$route.query.ythflag,
      active2: this.$route.query.active2, //当日任务 全部任务
      levelNum: 3, //用户等级 2是市级 3是省级
      priceDate: this.$route.query.priceDate,
      lateReportTime: this.$route.query.lateReportTime,
      stateId: this.$route.query.stateId,
      dis: false, //
      shState: false, //审核状态
      cxState: true, //撤销审核状态
      backState: false, //退回状态
      saveState: false, //保存状态
      cxShiState: false, //市审核的时候没有撤销审核
      thCityState: false, //区县审核审核的时候没有退回
      //
      showDetial: false, //展示商品说明
      shopIndex: "",
      shopName: "", //商品名称
      bqPrice: "", //本期价格
      bqPriceSave:'',
      contentSave:"",
      isGoods:"", //无此品种  1无，0有
      brand: "", //品牌
      ifShow: "", //为0的时候不显示 品牌文本框,1显示
      content: "", //说明
      comments: "", //备注
      originBrand:'',//品牌产地
      originBrandShow:false,
      itemNumbersShow:false,
      itemNumbers:'',//数量
      shopIndex1: "",
      //退回原因
      backInfo: "",
      showBackInfo: false,
      //查看日志
      showLog: false, //展示日志列表
      logList: [], //日志列表
      showLogDetial: false, //展示日志详情
      //
      todayCardList: [], //当日审核任务
      nextIndex: 0, //点击下一次下标
      //
      loginStatus: true,

      taskName: "", //任务名称
      stationName: "", //监测点
      editType: "1", //2是
      stationname: 1,
      stationList: [],
      StationCode: "",
      shopIdList: [], //taskId
      dropdownInput:'',
      inputTable:[],
      showDrop:false,
      lastStation:'', //判断是否是最后一个监测点
      titleShow: "审核通过",
      btnFlag:'',
      ids: [], //数据
      dayTaskId: '',
      detailData: {},

    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    // onRefresh() {
    //   //瀑布流刷新函数
    //   setTimeout(() => {
    //     this.isLoading = false
    //     this.init()
    //   }, 300)
    // },
    init() {
      this.checkLogin();
      if (this.loginStatus) {
        loading(true);
        this.dataGrid();
        this.getTodayCheck();
      }
    },
    getStationList() {
      getCheckStationList({
        taskCode: this.taskCode,
        exeno: this.exeno,
        stateId:this.stateId,
      }).then((res) => {
        res.forEach(i=> {
          i.value = i.codeValue
          i.text = i.codeName
        })
        this.stationList = res;
        this.inputTable=res
        this.dataGrid();
      });
    },
     dropClick(code, name) {
        this.dropdownInput = name;
        this.showDrop = !this.showDrop;
        this.jump(code)
    },
    hideTabs() {//隐藏展示滚动tabs
        this.fuzzyQuery(this.dropdownInput);
        this.showDrop = true;
    },
    showTabs() {//展示滚动tabs
        this.showDrop = false;
    },
    fuzzyQuery(keyWord) {//搜索筛选方法
        // if(keyWord.length==0) {
        //     return
        // }
        const arr = [];
        for(let i = 0;i < this.stationList.length;i++) {
            if(this.stationList[i].text.indexOf(keyWord) >= 0) {
                arr.push(this.stationList[i]);
            }
        }
        // console.log(this.inputTable);
        this.inputTable = arr;
    },
    // 跳转至监测点指定位置
   jump(value){
    this.$nextTick(() => {
      setTimeout(() => {
          document.getElementById(value).scrollIntoView({ behavior: "smooth",block: "center", });
        })
      })
    },
   //置顶图标
    backTop() {
        const that = this
        const timer = setInterval(() => {
            const ispeed = Math.floor(-that.scrollTop / 5)
            document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
            if (that.scrollTop === 0) {
                clearInterval(timer)
            }
        }, 16)
    },
      // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
    scrollToTop() {
        const that = this
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        that.scrollTop = scrollTop
        that.btnFlag = that.scrollTop > 130;
        // that.isBarNav = that.scrollTop > 10;
    },
    // 价格审核 houcc 2021.06.15 当日任务 this.$route.query.id
    getTodayCheck() {
      getTodayCheckNew({
        active: 0,
      }).then((res) => {
        this.todayCardList = res;
      });
    },
    onClickNext() {
      //点击下一个
      if (this.nextIndex >= this.todayCardList.length - 1) {
        //超过下标，从0开始
        this.nextIndex = 0;
      } else {
        this.nextIndex++;
      }
      let item; //空对象
      if (this.todayCardList.length != 0) {
        item = this.todayCardList[this.nextIndex];
        if (item == undefined) return;

        (this.code = item.tempCode),
          (this.taskCode = item.taskCode),
          (this.exeno = item.exeno),
          (this.ExeNo = item.ExeNo),
          (this.StationCode = item.stationCode),
          (this.RegionCode = item.RegionCode),
          // this.userCompName = item.userCompName,
          (this.taskID = item.taskID),
          (this.stationName = item.stationName),
          (this.tempCode = item.tempCode),
          (this.shopId = item.shopId),
          (this.shispflag = item.shispflag), //市审核
          (this.shengspflag = item.shengspflag), //市审核 //1蓝2绿3灰
          (this.ythflag = item.ythflag);

        loading(true);
        setTimeout(() => {
          this.dataGrid();
        }, 300);
      } else {
        Toast("没有待审记录!");
      }
    },

    isTruelevelNum(levelNum, ext) {
      //判断底部按钮的状态
      ext = ext + ""
      //未填报0,未提交1,县市区已退回89,市级已退回90,省级已退回99
      if (levelNum == 1  || (levelNum == 2 && ["0", "1"].indexOf(ext)> -1)) {
        //区县账户
        this.titleShow = "上报";
        this.thCityState=true;//区县没有退回
        this.cxShiState=true;//区县没有撤销审核
        return ["0", "1",].indexOf(ext) == -1;
      } else if (levelNum == 2) {
        //设区市待审核 21
        this.cxShiState=true;//市没有撤销审核
        return (
          ["0", "1","21"].indexOf(ext) == -1
        );
      } else {
        //省级待审核 31
        if(ext!='32'){
            this.cxState = true; //撤销审核状态
        }
        return (
          ["0", "1","31"].indexOf(ext) == -1
        );
      }
    },
    //houcc 2021.04.07
    dataGrid() {
      if (this.active2 == 1 || this.isTruelevelNum(this.levelNum, this.stateId) ) {
        //已审核
        //全部任务查看，按钮置灰色
        this.shState = true; //审核状态
        this.cxState = true; //撤销审核状态
        this.backState = true; //退回状态
        this.saveState = true; //保存状态
      }
      if(this.stateId=='32' && this.levelNum==3 && this.active2 == 0){//省级已审核
        this.shState = true; //审核状态
        this.cxState = false; //撤销审核状态
        this.backState = true; //退回状态
        this.saveState = true; //保存状态
      }
      var last=this.stationList.slice(-1)
      if(last.length>0) {
        this.lastStation=last[0].value
      }
      getExamDetailsList({
        ...this.$route.query
      }).then((resTwo) => {
        let hbNum; //环比
        let result = resTwo.data
        const res = result.dataList
        this.dayTaskId = result.dayTaskId
        this.stationList = []
        res.forEach(i=> {
          i.HB = ''
          i.StandardName = i.standardName
          i.TargetName = i.targetName
          i.ThisPrice = i.currentPrice
          i.ringPrice = i.ringPeriodAvgPrice
          i.UnitName = i.unitName
          i.VarietyCode = i.goodsCode
          i.VarietyName = i.goodsName
          i.Memo = i.remark
          i.stationname = i.stationName
          i.StationCode = i.stationCode
          i.hbjks = i.setRingDownRate
          i.hbzks = i.setRingUpRate
          let sta = this.stationList.map(i=>i.value)
          if(!sta.includes(i.stationCode)) {
            this.stationList.push({
              text: i.stationName,
              value: i.stationCode
            })
          }

        })
        this.StationCode = this.stationList.map((item) => item.value).join(",");
        // const columnMap = result.columnMap ? result.columnMap : {}
        // const arr = Object.keys(columnMap)
        // arr.forEach(i=> {
        //   res.forEach(j=> {
        //     if(i == j.VarietyCode) {
        //       if(columnMap[i].itemNumbers) {
        //         j.itemNumbersShow = true
        //       }else {
        //         j.itemNumbersShow = false
        //       }
        //       if(columnMap[i].originBrand) {
        //         j.originBrandShow = true
        //       }else {
        //         j.originBrandShow = false
        //       }
        //     }
        //   })
        // })
        for (let i = 0; i < res.length; i++) {
          // this.shopIdList.push(res[i].shopId);

          // this.taskName = res[i].taskName;
          this.stationName = res[i].stationname;

          let ringPrice = res[i].ringPrice; //上期 ringPrice
          let thisPrice = res[i].ThisPrice; //本期 ThisPrice
          if (res[i].ThisPrice == -1 || res[i].ThisPrice == "-") {
            res[i].ThisPrice = "";
          }
          if (!Number(ringPrice) || ringPrice == 0 || !Number(thisPrice)) {
            res[i].hbNum = "-";
            continue;
          }
          ringPrice = parseFloat(ringPrice);
          thisPrice = parseFloat(thisPrice);
          hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
          if (hbNum == Infinity || isNaN(hbNum)) {
            res[i].hbNum = "-";
          } else {
            if (
              hbNum.toString().indexOf(".") != -1 &&
              hbNum.toString().split(".")[1].length > 2
            ) {
              hbNum = hbNum.toFixed(2);
            }
            if (parseInt(hbNum) > 0) {
              res[i].styleColor = "red";
              res[i].HB = "<span style='color:red'>涨" + hbNum + "<span>";
            } else if (parseInt(hbNum) < 0) {
              res[i].styleColor = "green";
              res[i].HB = "<span style='color:green'>跌" + hbNum + "<span>";
            } else {
              res[i].styleColor = "black";
              res[i].HB = hbNum;
            }
            res[i].hbNum = hbNum;
          }
        }
        this.list = res;
        console.log(this.list);
        this.shopIdList = Array.from(new Set(this.shopIdList)); //去重
        loading(false);
      });
    },
    //环比实时变化
    changePrice(i) {
      let hbNum;
      let ringPrice = this.list[i].ringPrice; //上期 ringPrice
      let thisPrice = this.list[i].ThisPrice; //本期 ThisPrice
      //report_digits
      if (!Number(thisPrice) || thisPrice == "") {
        this.list[i].hbNum = "-";
        return;
      }
      if (thisPrice.split(".").length - 1 > 1) {
        Toast("本期价格输入格式不正确请重新输入!");
        return;
      }
      thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits);
      this.list[i].ThisPrice = thisPrice;
      if (!Number(ringPrice) || ringPrice == 0) {
        this.list[i].hbNum = "-";
        return;
      }
      ringPrice = parseFloat(ringPrice);
      thisPrice = parseFloat(thisPrice);
      hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
      if (hbNum == Infinity || isNaN(hbNum)) {
        this.list[i].hbNum = "-";
      } else {
        if (hbNum > 0) {
          this.list[i].styleColor = "red";
        } else if (hbNum < 0) {
          this.list[i].styleColor = "green";
        } else {
          this.list[i].styleColor = "black";
        }
        if (
          hbNum.toString().indexOf(".") != -1 &&
          hbNum.toString().split(".")[1].length > 2
        ) {
          hbNum = hbNum.toFixed(2);
        }
        this.list[i].hbNum = hbNum;
      }
    },
    //区县审核 cityCheck
    countyCheck() {
      loading(true)
      countyCheck({
        // ID: this.shopId,
        ID: this.shopIdList.toString(),
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = true; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
          this.cxShiState = true;
        } else {
          //   Toast.fail('审核失败,请稍后再试!')
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //区县保存
    countySaveRow() {
      loading(true)
      countySaveRow({
        taskID: this.taskID,
        TempCode: this.code?this.code:'',
        exeno: this.exeno,
        PriceDate: this.priceDate,
        // RegionCode: this.RegionCode,
        StationCode: this.StationCode,
        shopTaskId: this.shopIdList.toString(),
        taskCode: this.taskCode,
        json: JSON.stringify(this.list),
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //区县退回
    countyRedo() {
      loading(true)
      countyRedo({
        ID: this.shopIdList.toString(),
        backInfo: this.backInfo,
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
        taskId: this.taskID,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = true; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //市审核 cityCheck
    cityCheck() {
      loading(true)
      cityCheck({
        ID: this.shopIdList.toString(),
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = true; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
          this.cxShiState = true;
        } else {
          //   Toast.fail('审核失败,请稍后再试!')
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //市级保存
    citySaveRow() {
      loading(true)
      citySaveRow({
        taskID: this.taskID,
        TempCode: this.code?this.code:'',
        exeno: this.exeno,
        PriceDate: this.priceDate,
        // RegionCode: this.RegionCode,
        StationCode: this.StationCode,
        shopTaskId: this.shopIdList.toString(),
        taskCode: this.taskCode,
        json: JSON.stringify(this.list),
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //市退回
    cityRedo() {
      loading(true)
      cityRedo({
        ID: this.shopIdList.toString(),
        backInfo: this.backInfo,
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
        taskId: this.taskID,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = true; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //省审核 provinceCheck
    provinceCheck() {
      loading(true)
      provinceCheck({
        ID: this.shopIdList.toString(),
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = true; //审核状态
          this.cxState = false; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
        } else {
          //   Toast.fail('审核失败,请稍后再试!')
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    // 撤销审核 provinceRevoke
    provinceRevoke() {
      loading(true)
      provinceRevoke({
        ID: this.shopIdList.toString(),
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = false; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = false; //退回状态
          // this.saveState = false; //保存状态
          this.saveState = true; //保存状态
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //省退回
    provinceRedo() {
      loading(true)
      provinceRedo({
        ID: this.shopIdList.toString(),
        backInfo: this.backInfo,
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
        taskId: this.taskID,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.shState = true; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    //省保存价格采集
    provinceSaveRow() {
      loading(true)
      let arr = []
      this.list.forEach(i=> {
        arr.push({
          varietyCode: i.VarietyCode,
          thisPrice: i.ThisPrice,
          stationcode: i.StationCode,
          remark: i.Memo,
          comments: i.comments,
          passState: i.passState,
          isGoods: i.isGoods,
          backInfo: i.backInfo
        })
      })
      provinceSavePriceRow({
        ExeNo: this.$route.query.exeNo,
        dayTaskId: this.dayTaskId ? this.dayTaskId : JSON.parse(sessionStorage.getItem("params")).taskId,
        flag: 0,
        priceJson: JSON.stringify(arr),
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    onClickLeft() {
      //   this.$router.go(-1)
      this.$router.push({
        path: "/junjiashenheNew",
        query: {
          ...JSON.parse(sessionStorage.getItem("params")),
          type: 1
        },
      });
    },
    // 点击导航栏右侧下一条按钮
    // onClickRight(){},
    onLoad() {
      //初始化table
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        this.finished = true;
      }, 1000);
    },
    tongguo() {
      if (!this.ifCheckUpOk()) return;
      //审核通过
      this.$dialog
        .confirm({
          message: "是否确认"+this.titleShow+"?",
        })
        .then(() => {
          // levelNum 1区县级 2 市级 3省级
          if (this.levelNum == 1) {
            this.countyCheck();
          } else if(this.levelNum == 2 && ["0", "1"].indexOf(this.stateId)> -1){
            this.saveRow(1,"5");
          } else if (this.levelNum == 2 && this.stateId=="21") {
            this.cityCheck();
          } else if (this.levelNum == 3) {
            this.provinceCheck();
          }
          // if (this.id != undefined || this.id != "") {
            //采价周期id
            this.getTodayCheck();
          // }
        })
        .catch(() => {});
    },
    chexiao() {
      //撤销修改
      this.$dialog
        .confirm({
          message: "是否确认撤销审核?",
        })
        .then(() => {
          this.provinceRevoke();
          // if (this.id != undefined || this.id != "") {
            //采价周期id
            this.getTodayCheck();
          // }
        })
        .catch(() => {});
    },
    tuihui() {
      //退回修改
      this.backInfo = "";
      this.showBackInfo = true;
    },
    saveClick() {
      this.stateId = this.stateId + ''

      if (!this.ifCheckSaveRow()) return;

      this.provinceSaveRow();
      return
      //保存 levelNum 1区县级 2 市级 3省级
      if (this.levelNum == 1) {
        this.countySaveRow();
      }else if(this.levelNum == 2 && ["0", "1"].indexOf(this.stateId)> -1){
        this.saveRow(0,"2")
      } else if (this.levelNum == 2 && this.stateId=="21") {
        this.citySaveRow();
      } else if (this.levelNum == 3) {
        this.provinceSaveRow();
      }
    },
    // 点击商品名
    clickStoreName(item, index) {
      this.shopIndex = index;
      this.detailData = item
      this.detailData.shopIndex1 = index + 1
      let reason = rulesInfoDeal(item)
      if(reason.isWarn && reason.warnMsg) {
        this.detailData.placeholder = reason.warnMsg
      }else {
        this.detailData.placeholder = ''
      }
      this.$refs.detailRef.initData(this.detailData)
    },
    // 关闭弹框
    closeBasic() {
      this.showDetial = false;
    },
    //保存弹框信息
    saveBasic(row) {
      if (row.bqPrice > 99999999) {
        row.bqPrice = 99999999;
      } else if (row.bqPrice < 0) {
        row.bqPrice = 0;
      }
      this.list[this.shopIndex].ThisPrice = row.bqPrice; //本期价格
      this.list[this.shopIndex].Memo = row.content;//说明
      this.list[this.shopIndex].comments = row.comments; //备注
      this.list[this.shopIndex].isGoods = row.isGoods?1:0; //无此品种
      this.list[this.shopIndex].importInfo = row.importInfo; //本期价格-字符
      this.$refs.listRef.changePrice('', this.shopIndex)
      // const { form } = this.msg;
      // for(let item in form) {
      //   this.list[this.shopIndex][item] = form[item]
      // }
    },
    changeIsGoods() {
      if(this.isGoods == true) {
        this.bqPriceSave = this.bqPrice
        this.bqPrice = 0.00
        this.contentSave = this.content
        this.content = '无此品种'
      }else {
        this.bqPrice = this.bqPriceSave
        this.content = this.contentSave == '无此品种' ? '' : this.contentSave
      }
    },
    // 关闭退回弹框
    closeBackInfo() {
      this.showBackInfo = false;
    },
    saveBackInfo() {
      this.$dialog
        .confirm({
          message: "退回之后不可再操作数据，是否确认退回?",
        })
        .then(() => {
          if (this.levelNum == 1) {
            this.countyRedo(); //区县退回
          } else if (this.levelNum == 2) {
            this.cityRedo(); //市退回
          } else if (this.levelNum == 3) {
            this.provinceRedo(); //省退回
          }
          // if (this.id != undefined || this.id != "") {
            //采价周期id
            this.getTodayCheck();
          // }
          this.showBackInfo = false;
        })
        .catch(() => {});
    },
    // 查看日志按钮
    chaKanRiZhi() {
      this.showLog = true;
      loading(true)
      this.getDateRecord();
    },
    //查看日志
    getDateRecord() {
      getDateRecord({
        taskId: this.taskID,
        exeNo: this.exeno,
        stationCode: this.StationCode,
      }).then((res) => {
        this.logList = res;
        loading(false)
      });
    },
    //监测登陆状态 houcc 2021.07.24
    checkLogin() {
      checkLogin({}).then((res) => {
        if (!res.success) {
          // nativeJSBridge.logout();
          this.$router.push({ path: "/loginOld" });
        }
        this.loginStatus = res.success;
      });
    },
    //判断是否复核判断条件 if(!this.ifCheckSaveRow()) return;
    ifCheckSaveRow() {
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (
          this.ifNullOrEmpty(item.Memo,0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != "") ||
          (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) ||
          (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0))
        ) {
          this.clickStoreName(this.list[i], i);
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          return false;
        }
        // if(item.ThisPrice && item.originBrandShow && !item.originBrand && !item.isGoods) {
        //   this.clickStoreName(this.list[i], i)
        //   Toast("数据"+item.VarietyName+"请填写品牌产地!")
        //   return false;
        // }
        // if(item.ThisPrice && item.itemNumbersShow && !item.itemNumbers && !item.isGoods) {
        //   this.clickStoreName(this.list[i], i)
        //   Toast("数据"+item.VarietyName+"请填写数量!")
        //   return false;
        // }
      }
      return true;
    },
    ifCheckUpOk() {
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (item.ThisPrice == "") {
          this.clickStoreName(this.list[i], i);
          Toast("本期价格不可为空!");
          return false;
        }
        if (this.ifNullOrEmpty(item.Memo,1)) {
            this.clickStoreName(this.list[i], i);
            Toast("数据"+item.VarietyName+"说明的字数不能太少，至少2个文字!")
            return false;
         }
        if (this.ifNullOrEmpty(item.Memo,0)&& (item.ThisPrice == 0 || (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) || (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0)) ) {
          this.clickStoreName(this.list[i], i);
            Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          return false;
        }
        if(item.ThisPrice && item.originBrandShow && !item.originBrand && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写品牌产地!")
          return false;
        }
        if(item.ThisPrice && item.itemNumbersShow && !item.itemNumbers && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写数量!")
          return false;
        }
      }
      return true;
    },
    ifNullOrEmpty(obj,type) {
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      if (type==0 &&  (typeof obj == "undefined" || obj == null || obj == "" || re.test(obj))
      ) {
        return true;
      }else if( !(typeof obj == "undefined" || obj == null || obj == "" || re.test(obj)) && obj.length<2 && type==1 ){
        return true;
      } else {
        return false;
      }
    },
    //保存价格采集
    saveRow(type,editType) {
      loading(true)
      saveRow({
        taskID: this.taskID,
        TempCode: this.code,
        ExeNo: this.exeno,
        priceDate:this.priceDate,
        StationCode: this.StationCode,
        // shopTaskId: this.shopId,
        shopTaskId:this.shopIdList.toString(),
        json: JSON.stringify(this.list),
        taskCode:this.taskCode,
        editType:editType,
      }).then(res => {
        if (res.success) {
          if (type == 1) {
                this.upOK();
                return;
              }
              loading(false)
              Toast.success(res.info)
        } else {
          Toast({
            message: res.info.replace(/<\/br>/g, '\n'),
            position: 'center',
            overlay:true,
            });
          Toast.setDefaultOptions({ duration: 3600 });
          setTimeout(() => {
            if(res.ids==undefined) return;
            if (res.ids != '') {
              this.ids = JSON.parse(JSON.stringify(res.ids.split(',')))
              let listIndex
              for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].VarietyCode == this.ids[0]) {
                  listIndex = i
                }
                for (let j = 0; j < this.ids.length; j++) {
                  if (this.list[i].VarietyCode == this.ids[j]) {
                    this.list[i].VarietyCodeNew = this.ids[j]
                    continue
                  }
                }
              }
              this.clickStoreName(this.list[listIndex], listIndex)
            }
          }, 3600)
        }
      })
    },
    //上报
    upOK() {
      upOK({
        shopTaskIds: this.shopIdList.toString(),
        // exeno: this.exeno,
        // taskCode:this.taskCode,
        // stationCode:this.StationCode,
      }).then(res => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message)
          this.shState = true; //审核状态
          this.cxState = true; //撤销审核状态
          this.backState = true; //退回状态
          this.saveState = true; //保存状态
        } else {
          this.ids = res.ids
          Toast.fail(res.message.replace(/<\/br>/g, '\n'))
        }
      })
    },
    },
};
</script>
<style lang="scss" scoped>
#jiageshenheNew {
  background: #f0f2f1;
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
  }
  //置顶图标
    .toTopIcon {
        z-index: 100;
        position: fixed;
        bottom: 6%;
        right: 6%;

        .van-icon {
            font-size: px2rem(100);
            color: #ffa800;
        }
    }
  .xinxi {
    padding-left: 0.463rem;
    padding-top: 0.3rem;
    width: calc(100vw - 0.463rem);
    height: 2.8rem;
    background-color: #ffffff;
    font-size: px2rem(36);
    color: #4494f3;
    vertical-align: middle;
  }
  .blue-box {
    display: inline-block;
    width: 0.06rem;
    height: 0.26rem;
    margin-right: 0.09rem;
    background-color: #4494f3;
  }
  .boxTitle {
    height: 1rem;
    line-height: 1rem;
    background-color: #5699e9;
    color: #ffffff;
    font-size: px2rem(36);
  }
  .table {
    height: calc(100% - 3.4rem);
    .input {
      display: inline-block;
      vertical-align: middle;
      //   height: 0.9rem;
      //   line-height: 0.9rem;
      width: 1.3rem;
      background-color: #fff;
      border: px2rem(1) solid #4494f3;
      input {
        margin: 0;
        border: 0;
        height: 0.8rem;
        vertical-align: middle;
        width: 1.3rem;
        outline: none;
        text-align: right;
      }
    }
    .even {
      display: flex;
      font-size: px2rem(36);
      background-color: #f2fbfe;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .odd {
      display: flex;
      font-size: px2rem(36);
      background-color: #e0f7ff;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .contentLimit {
      //表格内容商品列限制三行展示
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn1 {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-size: px2rem(45);
      color: #2c7fe2;
      font-weight: bold;
      font-family: "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
      width: 2rem;
      // border-right: 1px solid #ababab;
    }
    v-button.btn1::after {
        content: '';
        width: 0.02rem;
        height: 0.6rem;
        background: #ababab;
        position: absolute;
        right: 0;
    }
    v-button.btn2::after {
        content: '';
        width: 0rem;
        height: 0rem;
    }
  }
  //审核过的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
  }
  .yincang {
    display: none;
  }
  .btn {
    display: inline-block;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    border-radius: 1rem;
    background-color: #3486e8;
    color: #ffffff;
    font-size: px2rem(45);
    text-align: center;
    vertical-align: middle;
  }
  /deep/.van-field--disabled .van-field__label {
    color: #000;
  }
  /deep/.van-field__control:disabled {
    color: #000;
    font-weight: bold;
    -webkit-text-fill-color: #000;
  }
  /deep/ .van-field__label {
    color: #000;
  }
  /deep/.van-cell {
    // padding: 5px 16px;
    line-height: 0.7rem !important;
  }
    /deep/.van-field__label {
      width: 1.2rem !important;
    }
  /deep/ .long-label .van-field__label {
    width: 1.5rem !important;
  }
  /deep/ .long-label2 .van-field__label {
    width: 1.8rem !important;
  }
  /deep/ .long-txt .van-field__label {
    width: 1.8rem !important;
    line-height: 0.5rem !important;
    margin-top: 0.2rem;
    margin-left: -0.23rem;
  }
  .goodIs {
    width: 1.9rem;
    font-size: 0.37037rem;
    line-height: 1.2rem;
    height: 1.2rem;
  }
  .g_disabled {
    /deep/.van-field__control:disabled {
      color: #c8c9cc!important;
      -webkit-text-fill-color: #c8c9cc!important;
    }
  }
  .logTable {
    height: calc(100% - 1rem);
    .no-con {
      color:#3e3e3e;
      font-size:px2rem(36);
      text-align:center;
      margin: 0 auto;
      padding: 2rem 0;
    }
  }
  .logTitle {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(60);
    font-weight: bold;
    text-align: center;
  }
  .logText {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(40);
    font-weight: bold;
    text-align: left;
  }
  .logBox {
    margin: px2rem(20) px2rem(15);
    padding: 0.1rem 0;
    padding-bottom: 0.35rem;
    background-color: #fff;
    font-size: px2rem(36);
    /deep/.van-row {
      margin-top: 0.15rem;
    }
    // border-radius: 25px;
  }
  .twoLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height:0.48rem;
  }
  .title {
   height: 30px;
    font-size: 16px;
    // color: #4494f3;
    color: #000;
    background-color: #ffffff;
    line-height: 30px;
    text-indent: 1em;
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow:ellipsis;
  }
  /deep/.van-card {
    padding: 0;
  }
   /deep/.van-search{
    height: 0.7rem;
  }
  .wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 4rem;
        left: 0;
        z-index: 1000;
        background-color: rgba(0,0,0,.7);
    }
    .block {
        position: relative;
        width: 100%;
        max-height: 50vh;
        background-color: #fff;
        color: #000;
        overflow-x: hidden;
        overflow-y:scroll;
        -webkit-overflow-scrolling:touch;
    }

}
</style>